<template>
    <div class="Records">
        <navbar></navbar>
        <section>
            <nav class="level">
                <div class="level-item has-text-centered">
                    <div>
                        <p class="control">
                            <button class="button is-info" @click="addRecord">Add Record</button>
                        </p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="control">
                            <button class="button is-info" v-if="this.$store.getters.isAdmin" v-bind:class="{'is-loading': csvDownloading}" @click="downloadCsv">Download CSV</button>
                        </p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="control">
                            <button class="button is-info" v-if="this.$store.getters.isAdmin" v-bind:class="{'is-loading': fullDownloading}" @click="downloadFull">Download Complete</button>
                        </p>
                    </div>
                </div>
                <div class="level-item has-text-centered">
                    <div>
                        <p class="control">
                            <button class="button is-info" v-if="this.$store.getters.isAdmin"  v-bind:class="{'is-loading': simpleDownloading}" @click="downloadSimple">Download Simple</button>
                        </p>
                    </div>
                </div>
            </nav>
        </section>
        <section>
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <div class="field">
                            <label class="label select-label">Location</label>
                            <div class="control">
                                {{current_location}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <div class="container">
                <div class="columns">
                    <div class="column is-full">
                        <div class="field">
                            <div>
                                <p class="control">
                                    <button class="button is-info"  @click="clearSorts">Clear Sorts</button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div v-if="!loading" class="column is-full records-table">
                        <table class="table is-hoverable">
                            <thead>
                            <tr>
                                <th @click="sort('last_name')">Last Name</th>
                                <th @click="sort('first_name')">First Name</th>
                                <th @click="sort('date_of_death')">Date of Death</th>
                                <th @click="sort('burial_number')">Burial Number</th>
                                <th @click="sort('section_name')">Section</th>
                                <th @click="sort('lot')">Lot</th>
                                <th @click="sort('space')">Space</th>
                                <th @click="sort('tier')">Tier</th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading">
                            <tr v-for="row in this.data" v-bind:key="row.id" @click="selected(row)">
                                <td>{{row.last_name}}</td>
                                <td>{{row.first_name}}</td>
                                <td>{{row.date_of_death}}</td>
                                <td>{{row.burial_number}}</td>
                                <td>{{row.section_name}}</td>
                                <td>{{row.lot}}</td>
                                <td>{{row.space}}</td>
                                <td>{{row.tier}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else-if="loading" class="column is-full records-table">
                        <Loader></Loader>
                    </div>
                    <div v-else class="column is-full is-size-5 is-pulled-left">Something went wrong.</div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="columns">
                    <div v-if="!loading" class="column is-full">
                        <nav class="pagination is-right" role="navigation" aria-label="pagination">
                            <button class="button pagination-next" @click="prevPage()">Previous</button>
                            <button class="button pagination-next" @click="nextPage()">Next page</button>
                            <ul v-if="(last_page - first_page < 4)" class="pagination-list">
                                <li><a class="pagination-link"
                                       v-bind:class="{'is-current':(current_page === first_page)}"
                                       @click.prevent="jumpPage(first_page)">{{first_page}}</a></li>
                                <li><a class="pagination-link"
                                       v-bind:class="{'is-current':(current_page === first_page * 1 + 1)}"
                                       @click.prevent="jumpPage(first_page * 1 + 1)">{{first_page * 1 + 1}}</a></li>
                                <li><a class="pagination-link"
                                       v-bind:class="{'is-current':(current_page === first_page * 1 + 2)}"
                                       @click.prevent="jumpPage(first_page * 1 + 2)">{{first_page * 1 + 2}}</a></li>
                            </ul>
                            <ul v-else-if="(last_page - first_page > 4) && (current_page < 3)" class="pagination-list">
                                <li>
                                    <a v-bind:class="{'pagination-link':true, 'is-current':(current_page == first_page)}"
                                       @click.prevent="jumpPage(first_page)">{{first_page}}</a></li>
                                <li>
                                    <a v-bind:class="{'pagination-link':true, 'is-current':(current_page == first_page * 1 + 1)}"
                                       @click.prevent="jumpPage(first_page * 1 + 1)">{{first_page * 1 + 1}}</a></li>
                                <li>
                                    <a v-bind:class="{'pagination-link':true, 'is-current':(current_page == first_page * 1 + 2)}"
                                       @click.prevent="jumpPage(first_page * 1 + 2)">{{first_page * 1 + 2}}</a></li>
                                <li><span class="pagination-ellipsis">&hellip;</span></li>
                                <li><a class="pagination-link" @click.prevent="jumpPage(last_page)">{{last_page}}</a>
                                </li>
                            </ul>
                            <ul v-else-if="(last_page - first_page > 4) && (current_page >= 3) && (current_page < last_page - 2)"
                                class="pagination-list">
                                <li><a class="pagination-link" @click.prevent="jumpPage(first_page)">{{first_page}}</a>
                                </li>
                                <li><span class="pagination-ellipsis">&hellip;</span></li>
                                <li><a class="pagination-link" @click.prevent="jumpPage(previous_page)">{{previous_page}}</a>
                                </li>
                                <li><a class="pagination-link is-current" @click.prevent="jumpPage(current_page)">{{current_page}}</a>
                                </li>
                                <li><a class="pagination-link" @click.prevent="jumpPage(next_page)">{{next_page}}</a>
                                </li>
                                <li><span class="pagination-ellipsis">&hellip;</span></li>
                                <li><a class="pagination-link" @click.prevent="jumpPage(last_page)">{{last_page}}</a>
                                </li>
                            </ul>
                            <ul v-else class="pagination-list">
                                <li><a class="pagination-link" @click.prevent="jumpPage(first_page)">{{first_page}}</a>
                                </li>
                                <li><span class="pagination-ellipsis">&hellip;</span></li>
                                <li>
                                    <a v-bind:class="{'pagination-link':true, 'is-current':(current_page == last_page * 1 - 2)}"
                                       @click.prevent="jumpPage(last_page * 1 - 2)">{{last_page * 1 - 2}}</a></li>
                                <li>
                                    <a v-bind:class="{'pagination-link':true, 'is-current':(current_page == last_page * 1 - 1)}"
                                       @click.prevent="jumpPage(last_page * 1 - 1)">{{last_page * 1 - 1}}</a></li>
                                <li><a v-bind:class="{'pagination-link':true, 'is-current':(current_page == last_page)}"
                                       @click.prevent="jumpPage(last_page)">{{last_page}}</a></li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Loader from "../components/Loader";

    export default {
        name: "Records",
        components: {Navbar,Loader},
        data() {
            return {
                data: [],
                per_page: 20,
                count: 0,
                first_page: 1,
                loading: true,
                fullDownloading: false,
                csvDownloading: false,
                simpleDownloading: false,
                sorts: []
            }
        },
        computed: {
            last_page() {
                return Math.ceil(this.count / this.per_page);
            },
            current_page() {
                return this.$route.query.page;
            },
            next_page() {
                return (this.$route.query.page * 1) + 1;
            },
            previous_page() {
                return (this.$route.query.page * 1) - 1;
            },
            current_location(){
                return this.$store.getters.default_location_name;
            },
        },
        mounted() {
            if (typeof this.$route.query.page === 'undefined') {
                this.$router.push({query: {page: "1"}})
            }
            this.getRecords();
        },
        methods: {
            selected(item) {
                let path = '/record/' + item.id;
                this.$router.push({path: path});
            },
            addRecord(event) {
                this.$router.push('/record');
            },
            getRecords() {
                this.loading = true;
                let page = this.$route.query.page;
                let url = process.env.VUE_APP_API;

                url = url + "/locations/" + this.$store.getters.default_location_id + "/burial-records?cursor=" + (page - 1) * this.per_page + "&limit=" + this.per_page;

                if(this.sorts.length > 0)
                {
                    url = url + "&sort=" + this.sorts.join(',');
                }
                this.$http.get(url)
                    .then(response => {
                        this.data = response.data.data;
                        this.loading = false;
                    });
                url = process.env.VUE_APP_API;
                this.$http.get(url + "/locations/" + this.$store.getters.default_location_id + "/burial-records/count")
                    .then(response => {
                        this.count = response.data.count;
                    })
            },
            nextPage() {
                let page = this.$route.query.page;
                page++;
                if (page > this.last_page) {
                    this.$router.push({query: {page: "" + this.last_page}});
                } else {
                    this.$router.push({query: {page: "" + page}});
                }
                this.getRecords();
            },
            prevPage() {
                let page = this.$route.query.page;
                page--;
                if (page < 1) {
                    this.$router.push({query: {page: "1"}});
                } else {
                    this.$router.push({query: {page: "" + page}});
                }
                this.getRecords();
            },
            jumpPage(page) {
                if (page > this.last_page) {
                    this.$router.push({query: {page: last_page}})
                } else if (page < 1) {
                    this.$router.push({query: {page: "1"}})
                } else {
                    this.$router.push({query: {page: page}})
                }
                this.getRecords();
            },
            downloadFull() {
                this.fullDownloading = true;
                let url = process.env.VUE_APP_API
                this.$http({
                    url: url + "/locations/" + this.$store.getters.default_location_id + "/reports?type=complete_pdf",
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    this.fullDownloading = false
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'completef.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    console.log(error);
                    this.fullDownloading = false
                });
            },
            downloadCsv() {
                this.csvDownloading = true;
                let url = process.env.VUE_APP_API
                this.$http({
                    url: url + "/locations/" + this.$store.getters.default_location_id + "/reports?type=complete_csv",
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    this.csvDownloading = false
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'complete.csv');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    console.log(error);
                    this.csvDownloading = false
                });
            },
            downloadSimple() {
                this.simpleDownloading = true;
                let url = process.env.VUE_APP_API
                this.$http({
                    url: url + "/locations/" + this.$store.getters.default_location_id + "/reports?type=simple_pdf",
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    this.simpleDownloading = false
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'simple.pdf');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(function (error) {
                    console.log(error);
                    this.simpleDownloading = false
                });
            },
            sort(s){
                let index = -1;
                index = this.sorts.indexOf(s);
                if(index == -1)
                {
                    index = this.sorts.indexOf('-'+s);
                    if(index == -1)
                    {
                        this.sorts.push(s);
                    }
                    else
                    {
                        this.sorts[index] = s;
                    }
                }
                else
                {
                    this.sorts[index] = ('-'+s);
                }
                this.getRecords();
            },
            clearSorts()
            {
                this.sorts = [];
                this.getRecords();
            }
        }
    }
</script>

<style scoped>
    .table {
        margin-left: auto;
        margin-right: auto;
        width: 100%;
    }
    .select-label {
        padding-top: 10px;
        text-align: left;
    }

    .records-table {
        height: 1000px;
    }
    table tr th:hover{
        background: hsl(217, 71%, 53%, 0.7);
        border-radius: 4px;
        color: #fff;
    }
</style>